import Alert from '@mui/material/Alert';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { ReimbursementStepActions } from '../components/ReimbursementStepActions';
import { useReimbursementDraft } from '../state/reimbursementDraftContext';

const CONDITION_KEYS = [
    'REIMBURSEMENT.TERMS.CONDITION_OPENED_IN_TIME',
    'REIMBURSEMENT.TERMS.CONDITION_ONE_REQUEST',
    'REIMBURSEMENT.TERMS.CONDITION_EVIDENCE',
    'REIMBURSEMENT.TERMS.CONDITION_REVIEW',
] as const;

export function TermsStep(): ReactElement {
    const { t } = useTranslation();
    const { draft, updateDraft } = useReimbursementDraft();

    return (
        <Stack spacing={3}>
            <Stack spacing={1}>
                <Typography variant="h5" component="h2">
                    {t('REIMBURSEMENT.TERMS.TITLE')}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    {t('REIMBURSEMENT.TERMS.DESCRIPTION')}
                </Typography>
            </Stack>

            <Alert severity="info" variant="outlined">
                <Stack component="ul" spacing={1} sx={{ m: 0, pl: 2 }}>
                    {CONDITION_KEYS.map((key) => (
                        <Typography key={key} component="li" variant="body2">
                            {t(key)}
                        </Typography>
                    ))}
                </Stack>
            </Alert>

            <FormControlLabel
                control={
                    <Checkbox
                        checked={draft.termsAccepted}
                        onChange={(event) => updateDraft({ termsAccepted: event.target.checked })}
                    />
                }
                label={t('REIMBURSEMENT.TERMS.ACCEPT')}
            />

            <ReimbursementStepActions currentStep="terms" nextDisabled={!draft.termsAccepted} />
        </Stack>
    );
}
